import { RefreshCw } from '@vitness/icons';
import { useStore } from '../lib/store';

function ago(minutes: number | null): string {
  if (minutes == null) return 'never synced';
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const h = Math.round(minutes / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}

export function SyncBadge({ compact = false }: { compact?: boolean }) {
  const sync = useStore(s => s.data?.sync);
  const syncing = useStore(s => s.syncing);
  const run = useStore(s => s.sync);

  const stale = (sync?.ageMinutes ?? 0) > 48 * 60;
  const colour = syncing ? 'var(--vn-info)' : stale ? 'var(--vn-warning)' : 'var(--vn-text-muted)';

  return (
    <button
      onClick={run}
      disabled={syncing}
      title={`Last sync: ${ago(sync?.ageMinutes ?? null)}`}
      className="vn-tb-ghost"
      style={{
        display: 'flex', alignItems: 'center', gap: 6,
        padding: compact ? '6px' : '6px 10px',
        borderRadius: 'var(--vn-radius-md)',
        border: '1px solid var(--vn-border-default)',
        background: 'transparent',
        color: colour,
        cursor: syncing ? 'wait' : 'pointer',
        fontFamily: 'var(--vn-font-mono)', fontSize: 10,
      }}
    >
      <RefreshCw
        size={13}
        style={syncing ? { animation: 'vd-spin 1s linear infinite' } : undefined}
      />
      {!compact && <span>{syncing ? 'Syncing…' : ago(sync?.ageMinutes ?? null)}</span>}
      <style>{`@keyframes vd-spin{to{transform:rotate(360deg)}}`}</style>
    </button>
  );
}
